import { Route } from './routeHelpers'

export function getPathElements(route: Route) {
  const p = route.params
  // route matching params can be a series of h1/h2/h3/h4 + facets
  if (p.h1 || p.facets) {
    const pathJoined = [p.h1, p.h2, p.h3, p.h4].filter((h) => !!h).join('/')
    const facets = Array.isArray(p.facets) ? p.facets[0] : p.facets
    return [pathJoined ? `${pathJoined}/` : '', facets]
  }
  // @TODO fix - pathMatch s now an array but was previosuly a string
  // have used join here to simulate old behaviour. Will no doubt need some
  // attentions and perhaps tidying up.
  // or a catch all
  let path = ''
  if (route.params.pathMatch) {
    path = route.params.pathMatch.join('/')
  }
  path = !path || path.endsWith('/') ? path : path + '/'

  let [hierarchyPath, facetPath] = path.split('-/', 2)
  if (Array.isArray(facetPath)) {
    facetPath = facetPath[0]
  }
  // if (!hierarchyPath?.endsWith('/')) {
  //   hierarchyPath = hierarchyPath + '/'
  // }
  return [hierarchyPath, facetPath]
}
